import { State } from "../common/reducers";
import { useSelector } from "react-redux";
import { createServiceCardData } from "../common/serviceCard/createServiceCardData";
import ServiceCardView, {
  IServiceCardData,
} from "../common/serviceCard/card.view";
import { BootstrapSpinner } from "../common/spinners/bootstrapSpinner";
import { useMunicipality } from "../Contexts/MunicipalityKey";

const Landing = () => {

  const roleChooser = useSelector((state:State) => state.role);
  const config = useSelector((state:State) => state.config);
  const municipality = useMunicipality();

  function createServiceCards() {
    const serviceCards = createServiceCardData(
      roleChooser.activeRole,
      config.config
    );
    return serviceCards.map((card: IServiceCardData, index: number) => (
      <ServiceCardView key={index} {...card} />
    ));
  }

  if (!roleChooser.loading && !config.loading) {
    return (
      <div className="container landing-container">
        <h1 className="landing-header">Min side</h1>
        {createServiceCards()}
      </div>
    );
  } else
    return (
      <div className="container">
        <div className="spinner">
          <BootstrapSpinner title="Laster" />
        </div>
      </div>
    );

}

export default Landing;